import { currencyUnits } from '@pdqdev/pdq-shared/dist/utils/currency-utils';

const CURRENCY_CODE_MAP: { [key: string]: string } = {
  US: 'USD',
};

export function getCurrencyUnitsOptions() {
  return currencyUnits.map((unit) => {
    return { label: unit, value: unit };
  });
}

export function normalizeCurrencyCode(code: string): string {
  return CURRENCY_CODE_MAP[code?.toUpperCase()] || code;
}
